import React from "react";
import logo from "../assets/Logolandscape.png";
import smlogo from "../assets/logo.png";	
import { FaChevronRight, FaChevronDown } from "react-icons/fa";
import { Link } from "react-router-dom";
import { LiaAnkhSolid } from "react-icons/lia";
import "../assets/css/megaDropdown.css";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">

      <div className="container">
        <div className="navbar-header" style={{marginBottom: "10px"}}>
          {/* Logo - Visible on Small Screens */}
          <a className="navbar-brand page-scroll" href="/">
            <img className="logo" src={logo} alt="Logo" />
          </a>
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
          {/* <li>
              <a href="/" className="page-scroll">
                Home
              </a>
            </li> */}
            <li className="dropdown dropdown-hover">
              <div className="page-scroll services-menu">
                Solutions
                <FaChevronDown className="caret-icon" />
                <div className="mega-dropdown">
                  <div className="dropdown-column">
                    <h4>Software</h4>
                    <ul>
                    <li><Link to="/erp-solutions">ERP</Link></li>
                    <li><Link to="/crm-solutions">CRM</Link></li>
                    <li><Link to="/mobile-applications">Mobile Applications</Link></li>
                    <li><Link to="/web-portals">Web Portals</Link></li> 
                    <li><Link to="/integrations">Integrations</Link></li>
                    <li><Link to="/edms-solutions">EDMS</Link></li>
                    <li><Link to="/ussd-and-sms">USSD, Bulk SMS & ChatBots</Link></li>
                    <li><Link to="/analytics-and-reporting">Analytics & Reporting</Link></li>
                    </ul>
                  </div>
                  <div className="dropdown-column">
                    <h4>Cloud Services</h4>
                    <ul>
                    <li><Link to="/cloud-network-design">Cloud Network Design</Link></li>
                    <li><Link to="/cloud-infrastructure-audit">Cloud Infrastructure Audit</Link></li>
                    <li><Link to="/cloud-optimization">Cloud Optimization</Link></li>
                    <li>
                      <a href="#">Cloud Deployments</a>
                      <ul className="nested-list" style={{ listStyleType: "disc" }}>
                        <li><Link to="/cloud-deployments">Azure</Link></li>
                        <li><Link to="/cloud-deployments">AWS</Link></li>
                        <li><Link to="/cloud-deployments">Google Cloud</Link></li>
                        <li><Link to="/cloud-deployments">Oracle</Link></li>
                        <li><Link to="/cloud-deployments">ServerCore</Link></li>
                      </ul>
                    </li>
                    </ul>
                  </div>
                  <div className="dropdown-column">
                    <h4>Unified Communication</h4>
                    <ul>
                      <li><Link to="/unified-communications">Microsoft 365</Link></li>
                      <li><Link to="/unified-communications">Google Suite</Link></li>
                      <li><Link to="/unified-communications">IceWarp</Link></li>
                    </ul>
                  </div>
                  <div className="dropdown-column">
                    <h4>Mobility</h4>
                    <ul>
                      <li><Link to="/mobility">Mobile device management</Link></li>
                      <li><Link to="/mobility">Intune</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            
            <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Industries
                  <FaChevronDown className="caret-icon" />
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><a href="#">Financial Services</a></li>
                  <li><a href="#">Non-Profit Organizarions</a></li>
                  <li><a href="#partner">Oil & Gas</a></li>
                  <li><a href="#">Public Sector</a></li>
                  <li><a href="#">Health Care</a></li>
                  <li><a href="#">ICT Solutions Providers</a></li>
                  <li><a href="#">Education</a></li>
                </ul>
              </div>
            </li>

           

            <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Infrastructure
                  <FaChevronDown className="caret-icon" />
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><Link to="/backup-and-disaster-recovery">Backup & Disaster Recovery</Link></li>
                  <li><Link to="/network-infrastructure-security">Network Infrastructure & Security</Link></li>
                  <li><Link to="/data-center-solutions">Datacenter Solutions</Link></li>
                  <li><Link to="/virtual-machines">Virtual Machines</Link></li>
                  <li><Link to="/kubernetes-setup">Kubernetes Setup</Link></li>
                  <li><Link to="/docker-web-apps"> Docker webapps setup</Link></li>
                  {/* <li className="nested-dropdown">
                    <div className="nested-title">
                      Virtual Machines <FaChevronRight className="caret-icon-right" />
                      {/* Nested Dropdown 
                      <ul className="nested-dropdown-content">
                        <li><a href="#">Kubernetes Setup</a></li>
                        <li><a href="#"> Docker webapps setup</a></li>
                      </ul>
                    </div>
                  </li> */}
                  <li><Link to="/cctv-camera-systems">CCTV</Link></li>
                  <li><Link to="/biometrics-solutions">Biometrics</Link></li>
                  <li><Link to="/end-user-devices">End user computing devices</Link></li>
                </ul>
              </div>
            </li>

            <li>
              <Link to="/managed-it" className="page-scroll">
                Managed IT
              </Link>
            </li>

            {/* <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Sofware
                  <FaChevronDown className="caret-icon" />
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><a href="#">ERP</a></li>
                  <li><a href="#">CRM</a></li>
                  <li><a href="#">Mobile Applications</a></li>
                  <li><a href="#">Web Portals</a></li> 
                  <li><a href="#">Integrations</a></li>
                  <li><a href="#">EDMS</a></li>
                  <li><a href="#">USSD, Bulk SMS & ChatBots</a></li>
                  <li><a href="#">Analytics & Reporting</a></li>
                </ul>
              </div>
            </li>
            {/* Cloud Services Dropdown */}
            {/* <li className="dropdown-hover">
                <div className="page-scroll">
                  Cloud Services 
                  <FaChevronDown className="caret-icon" />
                </div>
                <ul className="dropdown-content">
                <li><a href="#">Cloud Network Design</a></li>
                  <li><a href="#">Cloud Infrastructure Audit</a></li>
                  <li><a href="#">Cloud Optimization</a></li>
                  <li className="nested-dropdown">
                    <div className="nested-title">
                      Deployments <FaChevronRight className="caret-icon-right" />
                    </div>
                    <ul className="nested-dropdown-content">
                      <li><a href="#">Azure</a></li>
                      <li><a href="#">AWS</a></li>
                      <li><a href="#">Google Cloud</a></li>
                      <li><a href="#">Oracle</a></li>
                      <li><a href="#">ServerCore</a></li>
                    </ul>
                  </li>
                </ul>
             </li>  */}

        
            {/* <li>
              <div className="dropdown dropdown-hover">
                <div tabIndex={0} role="button" className="page-scroll m-1">
                  Unified Communications
                  <FaChevronDown className="caret-icon" />
                </div>
                <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box">
                  <li><a href="#">Microsoft 365</a></li>
                  <li><a href="#">Google Suit</a></li>
                  <li><a href="#">Icewrap</a></li>
                </ul>
              </div>
            </li> */}
            <li>
              <Link to="/about-us">
                About Us
              </Link>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Top Navbar - Hidden on Small Screens */}
      <div className="top-nav hidden-xs">
        <div className="container-fluid">
          {/* Logo on the Left */}
          {/* <div className="logo-container">
            <a className="navbar-brand page-scroll" href="/">
              <img className="logo" src={smlogo} alt="Logo" />
            </a>
          </div> */}

          {/* Contacts on the Right */}
          <div className="contacts">
            <span>📍 National Water Plaza, Ground Floor, Dunga Rd.</span>
            <span>📞 +254 795 022 244</span>
            <span>✉️ info@infrasoft.co.ke</span>
          </div>
        </div>
      </div>
    </nav>
  );
};
